import { RefurbishedOrderLineInterface } from "../../../common/interfaces/apiV2/shared/RefurbishedOrderLineInterface";

export interface MappedOrderLineDisplay {
    id: string;
    name: string;
    image: string;
    status: string;
    grade?: string;
    price: string;
    originalPrice?: string;
    serialNumber?: string;
    productIdentifier?: string;
}

export const mapOrderLineToDisplay = (
    line: RefurbishedOrderLineInterface,
    refurbishedStatus: string,
): MappedOrderLineDisplay => ({
    id: String(line.refurbished_product_id),
    name: line.product_name,
    image: line.product_image,
    status: refurbishedStatus,
    grade: line.grade_label,
    price: line.discount_grade_price,
    originalPrice:
        line.product_price !== line.discount_grade_price
            ? line.product_price
            : undefined,
    serialNumber: line.serial_number,
    productIdentifier: line.product_identifier,
});
